import { Button, Flex, Input, Tag, Typography } from 'antd';
import { IconRefresh, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

const { Paragraph, Title } = Typography;

export interface SettingsHeaderProps {
  search: string;
  dirtyCount: number;
  isRefreshing: boolean;
  onSearchChange: (value: string) => void;
  onDiscardAll: () => void;
  onRefresh: () => void;
}

export function SettingsHeader({
  search,
  dirtyCount,
  isRefreshing,
  onSearchChange,
  onDiscardAll,
  onRefresh,
}: SettingsHeaderProps) {
  const { t } = useTranslation('settings');

  return (
    <Flex
      justify="space-between"
      align="flex-start"
      gap={24}
      wrap
      className="platform-settings-header"
    >
      <Flex vertical gap={4}>
        <Flex align="center" gap={10} wrap>
          <Title level={2}>{t('page.title')}</Title>
          {dirtyCount > 0 ? (
            <Tag color="gold">
              {t('page.unsavedCount', { count: dirtyCount })}
            </Tag>
          ) : null}
        </Flex>
        <Paragraph type="secondary">{t('page.subtitle')}</Paragraph>
      </Flex>

      <Flex vertical gap={12} align="flex-end">
        <Flex gap={8}>
          <Button
            icon={<IconRefresh size={16} />}
            loading={isRefreshing}
            onClick={onRefresh}
          >
            {t('actions.refresh')}
          </Button>
          <Button
            danger
            icon={<IconTrash size={16} />}
            disabled={dirtyCount === 0}
            onClick={onDiscardAll}
          >
            {t('actions.discardAll')}
          </Button>
        </Flex>
        <Input.Search
          allowClear
          value={search}
          placeholder={t('page.searchPlaceholder')}
          onChange={(event) => onSearchChange(event.target.value)}
          className="platform-settings-search"
        />
      </Flex>
    </Flex>
  );
}
